import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ButtonLegacyModule, ButtonThemeLegacy, IconModule, IconName } from 'studio-components';

@Component({
  selector: 'studio-toggle-button',
  standalone: true,
  imports: [CommonModule, ButtonLegacyModule, IconModule],
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
})
export class ToggleButtonComponent {
  @Input() public active = false;
  @Input() public iconActive: IconName;
  @Input() public iconInactive: IconName;
  @Input() public tooltip: string = null;
  @Input() public theme: ButtonThemeLegacy = 'dark-primary';
}
